import { Box, CheckBox } from 'grommet';
import React from 'react';

export const CheckboxOption = React.memo(({ label, selected }: { label: string, selected: boolean }) => (
    <Box direction="row" gap="small" align="center" pad="small">
      <CheckBox checked={selected} onChange={() => null}/>
      <span style={{ fontSize: '18px' }}>{label}</span>
    </Box>
));
